import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneAC_NT_CM_Commitment = createAsyncThunk(
  "AC_NT_CM_Commitment/GetOneAC_NT_CM_Commitment",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AC_NT_CM_Commitment/GetOneAC_NT_CM_Commitment",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAC_NT_CM_Commitment = createAsyncThunk(
  "AC_NT_CM_Commitment/UpdateAC_NT_CM_Commitment",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AC_NT_CM_Commitment/UpdateAC_NT_CM_Commitment",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const Commitment = createSlice({
  name: "Commitment",
  initialState: {
    //------------- GetCommitment ---------------------
    Commitment: {},
    loadingCommitment: false,
    errorCommitment: null,
    //------------- UpdateCommitment ---------------------
    UpdateCommitment: {},
    loadingUpdateCommitment: false,
    errorUpdateCommitment: null,
  },
  reducers: {
    setCommitment: (state, action) => {
      state.Commitment = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetOneAC_NT_CM_Commitment.pending, (state, action) => {
        console.log(action.payload, "action.payload");

        state.loadingCommitment = true;
        state.Commitment = action.payload;
        state.errorCommitment = null;
      })
      .addCase(GetOneAC_NT_CM_Commitment.fulfilled, (state, action) => {
        state.loadingCommitment = false;
        state.Commitment = action.payload;
      })
      .addCase(GetOneAC_NT_CM_Commitment.rejected, (state, action) => {
        state.loadingCommitment = false;
        state.Commitment = action.payload;
      });
    //------------------- UpdateAC_NT_CM_Commitment -----------------------------------
    builder
      .addCase(UpdateAC_NT_CM_Commitment.pending, (state, action) => {
        state.loadingUpdateCommitment = true;
        state.UpdateCommitment = action.payload;
        state.errorUpdateCommitment = null;
      })
      .addCase(UpdateAC_NT_CM_Commitment.fulfilled, (state, action) => {
        state.loadingUpdateCommitment = false;
        state.UpdateCommitment = action.payload;
      })
      .addCase(UpdateAC_NT_CM_Commitment.rejected, (state, action) => {
        state.loadingUpdateCommitment = false;
        state.errorUpdateCommitment = action.payload;
      });
  },
});
export const { setCommitment } = Commitment.actions;

export default Commitment.reducer;
